import { ChevronRightIcon } from "@heroicons/react/outline";
import { RECIPIENT_COLOUR_MAP } from "../utils";
import { SignatureConfig } from "../interfaces";
import { useTranslation } from "react-i18next";

interface Props {
  signatureConfig: SignatureConfig;
  activeRecipient?: number | null;
  onSelectRecipient?: (recipientNumber: number) => void;
}

function SignatureRequestEmailRecipients(props: Props) {

  const { signatureConfig, activeRecipient, onSelectRecipient } = props;

  const { t } = useTranslation();

  return (
    <div className="flex items-center relative my-1 flex-shrink-0 gap-1 overflow-x-auto overflow-y-hidden scrollbar-hidden w-[700px] pr-[64px]">
      {[...Array(signatureConfig.numRecipients)].map((_, index: number) => {
        const recipientNumber = index + 1;

        // @ts-ignore
        const recipientEmail: string = signatureConfig["recipientEmail" + recipientNumber];
        const hubspotContactLabel = recipientEmail.match(/{{__hscontact_(.+?)(?::(.+))?}}/);

        const hasOverride = !!signatureConfig.overrides?.some(o => o.recipientNumber === recipientNumber);

        // When editing a recipient override, fade out the other recipients
        // Otherwise on the default email, fade out the recipients that have their own override
        const isFaded = activeRecipient
          ? activeRecipient !== recipientNumber
          : hasOverride;

        return (
          <div key={recipientNumber} className='flex items-center gap-1 flex-shrink-0'>
            {recipientNumber > 1 &&
              <ChevronRightIcon className='w-4 h-4 text-gray-400' />
            }
            <div
              className={`${RECIPIENT_COLOUR_MAP[recipientNumber][1]} ${isFaded ? "opacity-40 hover:opacity-70" : ""} ${onSelectRecipient ? "cursor-pointer" : ""} relative text-white text-xs rounded-full px-2 pt-1 font-semibold flex-shrink-0`}
              onClick={() => onSelectRecipient?.(recipientNumber)}
            >
              {recipientNumber}. {hubspotContactLabel
                ? hubspotContactLabel[2] || t("Contact")
                : recipientEmail || t("Email Required")
              }
              {!recipientEmail &&
                <div className='bg-yellow w-2 h-2 rounded-full absolute -right-0.5 top-0'></div>
              }
              {(recipientEmail && hasOverride) &&
                <div className='w-2 h-2 flex-col items-center justify-center text-white rounded-full absolute text-lg right-0.5 -top-0.5'>*</div>
              }
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default SignatureRequestEmailRecipients;
